export default __webpack_public_path__ + "16b188c91304a9ffaaf67c3f3490403a.svg";